module.exports = __webpack_public_path__ + "img/fi-rr-home.fe74149d.svg";